import React, { useState } from 'react';

import Setting from './Components/Setting';
import { DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';

import { fetchUserInfo } from '@api/login';
import { fetchNumOfUnreadAlert } from '@api/alert';
import useAsync from '@util/hooks/useAsync';

import DropDownHeader from './Components/DropDownHeader';
import ProfileModal from '../UserBoxPopup/ProfileModal';
import LogoutModal from '../UserBoxPopup/LogoutModal';
import PersonalizationModal from '../UserBoxPopup/PersonalizationModal';

const UserBox = () => {
    const [userInfo, setUserInfo] = useState({});
    useAsync({
        promise: fetchUserInfo,
        immediate: true,
        resolve: res => {
            const { userID, userName, userEmail } = res;
            setUserInfo({ userID, userName, userEmail });
        },
        reject: error => console.error(error),
    });

    const [count, setCount] = useState(0);
    const { promise: getNumOfUnreadAlert } = useAsync({
        promise: fetchNumOfUnreadAlert,
        resolve: res => {
            const { count } = res;
            setCount(count);
        },
        reject: error => console.error(error),
    });

    const [logoutModal, setLogoutModal] = useState(false);
    const toggleLogoutModal = () => {
        setLogoutModal(!logoutModal);
    };

    const [profileModal, setProfileModal] = useState(false);
    const toggleProfileModal = () => {
        setProfileModal(!profileModal);
    };

    const [personalizationModal, setPersonalizationModal] = useState(false);
    const togglePersonalizationModal = () => {
        setPersonalizationModal(!personalizationModal);
    };

    return (
        <div className="user-box ml-2">
            <UncontrolledButtonDropdown>
                <DropdownToggle
                    color="link"
                    className="user-btn p-0 border-0 text-decoration-none"
                    onClick={getNumOfUnreadAlert}
                >
                    <span className="material-icons-round">person_outline</span>
                    <div className="user-name">
                        <b>{userInfo.userName}</b>
                    </div>
                    <span className="material-icons-round">arrow_drop_down</span>
                </DropdownToggle>
                <DropdownMenu right className="user-options rm-pointers p-0 border-0">
                    <DropDownHeader count={count} userInfo={userInfo} toggleLogoutModal={toggleLogoutModal} />
                    <Setting
                        toggleProfileModal={toggleProfileModal}
                        togglePersonalizationModal={togglePersonalizationModal}
                    />
                </DropdownMenu>
            </UncontrolledButtonDropdown>
            <LogoutModal initModal={logoutModal} toggleModal={toggleLogoutModal} />
            <ProfileModal initModal={profileModal} toggleModal={toggleProfileModal} userInfo={userInfo} />
            <PersonalizationModal initModal={personalizationModal} toggleModal={togglePersonalizationModal} />
        </div>
    );
};

export default UserBox;
